import PlatformActions from './PlatformActions'

export default class VIACASINOActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'VIACASINO',
      gameType: 'LIVE',
      gameCode: 'VIACASINO-LIVE-001',
    }

    this.constantGameInfo = {
      hostNickname: 'BaiBai',
      liveType: 'DEALER',
    }

    this.gameName = 'Classic Baccarat'
  }

  getBetMessage(txnList) {
    const { currency, userIdPrefix, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betType,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `m-${txnId}`, // m-1833398750463365121
      roundId: `awc${currency.toLowerCase()}_${userIdPrefix}${userId}_${roundId}`, // awcstgthb_ts0thbtest15070144820004
      betType,
      currency,
      betTime,
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        ...this.constantGameInfo,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const { currency, userIdPrefix } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      updateTime,
      roundId,
      betType,
      betTime,
      turnover,
      betAmount,
      winAmount,
      resultData,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `m-${txnId}`, // m-1833398750463365121
      roundId: `awc${currency.toLowerCase()}_${userIdPrefix}${userId}_${roundId}`, // awcstgthb_ts0thbtest15070144820004
      refPlatformTxId: null,
      settleType: 'platformTxId',
      updateTime,
      betType,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        ...this.constantGameInfo,
        resultData,
        rebate: 0,
        tableId: '507',
        betGameModes: JSON.stringify(betType.split(',')),
      },
    }))
    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getResettleMessage(txnList) {
    const { currency, userIdPrefix } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      updateTime,
      roundId,
      betType,
      betTime,
      turnover,
      betAmount,
      winAmount,
      resultData,
      resettleTime,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `m-${txnId}`, // m-1833398750463365121
      roundId: `awc${currency.toLowerCase()}_${userIdPrefix}${userId}_${roundId}`, // awcstgthb_ts0thbtest15070144820004
      refPlatformTxId: null,
      settleType: 'platformTxId',
      updateTime,
      betType,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      gameInfo: {
        ...this.constantGameInfo,
        resultData,
        rebate: 0,
        tableId: '507',
        betGameModes: JSON.stringify(betType.split(',')),
        resettleTime,
      },
    }))

    const message = {
      action: 'resettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getVoidBetMessage(txnList) {
    const { currency, userIdPrefix } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `m-${txnId}`, // m-1833398750463365121
      roundId: `awc${currency.toLowerCase()}_${userIdPrefix}${userId}_${roundId}`, // awcstgthb_ts0thbtest15070144820004
      betAmount,
      updateTime,
      voidType: 2,
      gameInfo: {
        ...this.constantGameInfo,
      },
    }))

    const message = {
      action: 'voidBet',
      txns,
    }

    return JSON.stringify(message)
  }

  getVoidSettleMessage(txnList) {
    const { currency, userIdPrefix } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
      betType,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `m-${txnId}`, // m-1833398750463365121
      roundId: `awc${currency.toLowerCase()}_${userIdPrefix}${userId}_${roundId}`, // awcstgthb_ts0thbtest15070144820004
      updateTime,
      betType,
      voidType: 2,
      betAmount,
    }))

    const message = {
      action: 'voidSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const { currency, userIdPrefix } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `m-${txnId}`, // m-1833398750463365121
      roundId: `awc${currency.toLowerCase()}_${userIdPrefix}${userId}_${roundId}`, // awcstgthb_ts0thbtest15070144820004
      gameInfo: {
        ...this.constantGameInfo,
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
